import { useParams } from "react-router-dom";
import { useFetchTeamById, useFetchTeamPersons } from "../../../api/hooks";
import Header from "../../../uikit/Header/Header";
import TeamGrid from "../components/TeamProfilesGrid";

export default function TeamProfileListing() {
  const { id } = useParams();
  const { data: team } = useFetchTeamById(id);
  const { data: persons } = useFetchTeamPersons(id);

  return (
    <>
      <Header />
      <TeamGrid
        title={team?.name || ""}
        callout={team?.pool || ""}
        persons={persons || []}
        backgroundImage={team?.logo_key || ""}
      />
    </>
  );
}
